import { render, staticRenderFns } from "./LuckyRule.vue?vue&type=template&id=66bf0fc5&scoped=true&"
import script from "./LuckyRule.vue?vue&type=script&lang=js&"
export * from "./LuckyRule.vue?vue&type=script&lang=js&"
import style0 from "./LuckyRule.vue?vue&type=style&index=0&id=66bf0fc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf0fc5",
  null
  
)

export default component.exports